var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 151,
    viewBox: "0 0 66 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7717 1.99998C28.1064 26.4415 30.5257 53.705 47.8713 72.6951C50.5762 75.6563 58.1055 81.7534 61.9652 77.1354C65.3524 73.0827 65.205 63.5207 61.9998 59.6171C53.6574 49.4571 39.8465 39.1439 29.5838 53.505C18.4115 69.139 14.6881 93.8485 13.2853 112.672C12.6049 121.802 12.507 132.847 14.4824 141.822C15.7937 147.78 16.4392 142.622 17.6918 138.954C19.4732 133.736 23.5866 121.688 19.6427 133.24C18.0402 137.933 17.0269 143.316 16.7922 147.938C16.5414 152.879 13.5739 144.248 12.8222 143.238C10.4524 140.051 6.27127 135.922 2.44782 134.616",
    stroke: "#1C1C1C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.03772ce81051ec2f22d5118ac964a35f.svg";
export { ForwardRef as ReactComponent };